import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { goniniBlue } from "../../../utils/gonini";

export const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: goniniBlue[500],
		color: "rgba(255,255,255,1)",
		boxShadow: theme.shadows[1],
		fontSize: 14,
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: goniniBlue[500],
	},
}));
